export default __webpack_public_path__ + "static/media/logoGameHub.03e913d5.png";